'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _desc, _value, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _isNumber = require('lodash/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _getNumeral = require('../../../helpers/getNumeral');

var _getNumeral2 = _interopRequireDefault(_getNumeral);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var NComponent = (_class = (_temp2 = _class2 = function (_React$Component) {
  (0, _inherits3.default)(NComponent, _React$Component);

  function NComponent() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, NComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = NComponent.__proto__ || Object.getPrototypeOf(NComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(NComponent, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!(0, _isNil2.default)(this.props.value)) {
        var label = this.formatValue(this.props.value);
        this.setState({ label: label });
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.value !== this.props.value) {
        if (!(0, _isNil2.default)(this.props.value)) {
          var label = this.formatValue(this.props.value);
          this.setState({ label: label, value: this.props.value });
        } else {
          this.setState({ label: '', value: this.props.value });
        }
      }
    }
  }, {
    key: 'unformatValue',
    value: function unformatValue(label) {
      return label === '' ? undefined : (0, _getNumeral2.default)()._.stringToNumber(label);
    }
  }, {
    key: 'formatValue',
    value: function formatValue(real) {
      return (0, _isNumber2.default)(real) ? (0, _getNumeral2.default)()(real).format('$0,0[.]00') : '';
    }
  }, {
    key: 'onChange',
    value: function onChange(event) {
      var label = event.target.value;
      if (!label) {
        this.setState({ label: '' });
        this.props.onChange(null);
        return;
      }
      var value = this.unformatValue(label);
      var formatted = this.formatValue(event.target.value);
      if (formatted) {
        this.setState({ label: formatted, value: value });
      } else {
        this.setState({ label: label, value: value });
      }
      this.props.onChange(value);
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      if (this.state.label) return this.state.label;
      if ((0, _isNil2.default)(this.props.value)) return '';
      var label = this.formatValue(this.props.value);
      return label;
    }
  }, {
    key: 'onBlur',
    value: function onBlur(event) {
      if (!event.target.value) return;
      var real = this.formatValue(event.target.value);
      this.setState({ label: real });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(event) {
      if (event.keyCode === 8) {
        if (String(this.props.value).length <= 1 || this.props.value === 0) {
          this.setState({ label: '' });
          this.props.onChange(null);
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'label' },
          this.props.label
        ),
        _react2.default.createElement(
          'div',
          { className: 'os-input-container' },
          _react2.default.createElement('input', (0, _extends3.default)({
            className: 'os-input-text',
            value: this.getValue(),
            onChange: this.onChange,
            onKeyDown: this.onKeyDown,
            onBlur: this.onBlur
          }, this.props.passProps))
        ),
        _react2.default.createElement(
          'div',
          { className: 'description' },
          this.props.description
        ),
        _react2.default.createElement(
          'div',
          { className: 'os-input-error' },
          this.props.errorMessage
        )
      );
    }
  }]);
  return NComponent;
}(_react2.default.Component), _class2.propTypes = {
  onChange: _propTypes2.default.func,
  value: _propTypes2.default.any,
  useHint: _propTypes2.default.bool,
  label: _propTypes2.default.any,
  errorMessage: _propTypes2.default.string,
  disabled: _propTypes2.default.bool,
  passProps: _propTypes2.default.object,
  description: _propTypes2.default.node
}, _temp2), (_applyDecoratedDescriptor(_class.prototype, 'onChange', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onChange'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onBlur', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onBlur'), _class.prototype), _applyDecoratedDescriptor(_class.prototype, 'onKeyDown', [_autobindDecorator2.default], Object.getOwnPropertyDescriptor(_class.prototype, 'onKeyDown'), _class.prototype)), _class);
exports.default = NComponent;